// Readable shortcuts (/settings/endpoints/browser-chats, /account) and older
// routes (/admin/identity, /governance) share one destination: the app's own
// URL. A Settings shortcut becomes an address (lib/settingsModel.js); Findings
// and Fleet keep their views; /governance and agent policy's old Settings
// paths open Governance.
import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { opensGovernance, settingForShortcut } from "../lib/settingsModel.js";

export function resolveShortcut(mode, requested) {
    const value = String(requested || "").toLowerCase();
    if (mode === "triage") return { mode: "triage", view: "triage" };
    if (mode === "governance" || opensGovernance(value)) return { mode: "governance" };
    const setting = settingForShortcut(value);
    if (mode === "endpoints" && !setting) return { mode: "endpoints", view: "endpoints" };
    return { mode: "settings", setting };
}

export default function SettingsRedirect({ mode = null, fixedView = null }) {
    const { view, section } = useParams();
    const [params] = useSearchParams();
    const resolved = resolveShortcut(mode, fixedView || (section ? `${view}/${section}` : view));
    const next = new URLSearchParams(params);
    for (const key of ["view", "menu", "settingsView", "adminView", "setting"]) next.delete(key);
    next.set("mode", resolved.mode);
    if (resolved.view) next.set("adminView", resolved.view);
    if (resolved.setting) next.set("setting", resolved.setting);
    return <Navigate to={{ pathname: "/", search: "?" + next.toString() }} replace />;
}
